const copyContent = {
  inserted(el) {
    const copyButton = document.createElement('button');
    const copiedButton = document.createElement('button');

    copyButton.type = 'button';
    copyButton.className = 'copy';
    copyButton.textContent = 'Clique para copiar';

    copiedButton.type = 'button';
    copiedButton.className = 'copied opacity-0';
    copiedButton.textContent = 'Copiado';

    el.appendChild(copyButton);
    el.appendChild(copiedButton);

    copyButton.addEventListener('click', () => {
      const contentToCopy = el.querySelector('.form-control').dataset.value;

      const textArea = document.createElement('textarea');
      textArea.value = contentToCopy;
      textArea.style.top = '0';
      textArea.style.left = '0';
      textArea.style.position = 'fixed';

      document.body.appendChild(textArea);

      textArea.focus();
      textArea.select();

      try {
        const successful = document.execCommand('copy');
        if (successful) {
          copyButton.className = 'copy opacity-0';
          copiedButton.className = 'copied';
        }
      } finally {
        document.body.removeChild(textArea);
      }
    });

    copiedButton.addEventListener('click', () => {
      copyButton.className = 'copy';
      copiedButton.className = 'copied opacity-0';
    });
  },
};

export default copyContent;
